import { List, MagnifyingGlass } from "@phosphor-icons/react";
import { Link, useRouterState } from "@tanstack/react-router";
import { Ic, useTick } from "@/components/bits";
import { useSyncedAt } from "@/data/live";
import { EVENT } from "@/lib/fields";
import { ago } from "@/lib/format";
import { capLevel } from "@/model/cap";
import { useApp } from "./appData";
import { PAGE_TITLE } from "./pages";

export function Topbar({ onMenu, onSearch }: { onMenu: () => void; onSearch: () => void }) {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const { cap } = useApp();
  const synced = useSyncedAt();
  const now = useTick(5000);
  const title = PAGE_TITLE[path] ?? "Overview";
  const pct = cap.cap ? Math.min(100, (cap.used / cap.cap) * 100) : 0;

  return (
    <header className="topbar">
      <button type="button" className="btn ghost icon menu-btn" aria-label="Open menu" onClick={onMenu}>
        <Ic i={List} />
      </button>
      <div className="crumbs">
        {path === "/" ? (
          <>
            <span className="par">Workspace</span>
            <span className="sep par">/</span>
            <b>{title}</b>
          </>
        ) : (
          <>
            <span className="par hide-md">{EVENT.name}</span>
            <span className="sep par hide-md">/</span>
            <span className="par">WhatsApp</span>
            <span className="sep par">/</span>
            <b>{title}</b>
          </>
        )}
      </div>
      <button type="button" className="ck-btn" aria-label="Search and commands" onClick={onSearch}>
        <Ic i={MagnifyingGlass} />
        <span className="lbl">Search</span>
        <span className="kbd">⌘K</span>
      </button>
      <Link to="/send" className="capm" title="Daily cap · unique phones in a rolling 24 hours" data-testid="cap-meter">
        <span className="lbl">Daily cap</span>
        <span className={`bar ${capLevel(cap.used, cap.cap)}`} data-level={capLevel(cap.used, cap.cap)}>
          <i style={{ width: `${pct}%` }} />
        </span>
        <b>
          {cap.used}/{cap.cap}
        </b>
      </Link>
      <span className="sync hide-sm" title="Last update from Firestore">
        <span className="dot" />
        <span className="lbl">Synced&nbsp;</span>
        <span>{ago(synced, now)}</span>
      </span>
    </header>
  );
}
